export default {
  presentation_pdf: 'Presentation',
  presentation_reveal: 'Presentation',
  material_type_for_rate_presentation_pdf: 'presentation',
  material_type_for_rate_presentation_reveal: 'presentation',
  material_type_for_rate_presentation: 'presentation',
  material_type_for_rate_exercise: 'exercise',
  material_type_for_rate_attachment: 'attachment',
  material_type_for_rate_quiz: 'quiz',
  material_type_for_rate_article: 'article',
  material_type_for_rate_snippet: 'snippet',
  'Privacy policy':
    'By registering, you accept <a href="https://coderslab.com/en/regulations" target="_blank">the Terms and Conditions</a> and <a href="https://coderslab.com/en/privacy-policy" target="_blank"> the Privacy Policy</a>.',
  'Instance id is missing': 'Select a course',
};
